import React from 'react';

const Footer = () => {
  return (
    <footer className="site-footer" id="contacto">
      <div className="wrapper footer-shell">
        <div>
          <p className="footer-brand">
            <span>que</span>
            <strong>Uauu!</strong>
          </p>
          <p>
            Si tienes una idea puntual, un proceso lento o una oportunidad nueva,
            escríbenos a <a href="mailto:info@queuauu.com">info@queuauu.com</a>.
          </p>
        </div>
        <p className="footer-copy">
          © {new Date().getFullYear()} que Uauu! IA aplicada para resultados reales.
        </p>
      </div>
    </footer>
  );
};

export default Footer; 